export const tabStatus = [
  {
    code: 1,
    label: 'opened',
    labelIcon: 'ic:round-bookmarks',
    group: 'active',
    step: 'open',
    stepAction: 'tabOpened',
    action: 'close',
    actionIcon: 'mdi:delete-variant' 
  },
  {
    code: 2,
    label: 'closing',
    labelIcon: 'eva:clock-fill',
    group: 'active',
    step: 'startClose',
    stepAction: 'startedClosing',
    action: `pay`,
    actionIcon: 'eva:bell-fill' 
  },
  {
    code: 3,
    label: 'paid',
    labelIcon: 'eva:checkmark-circle-fill',
    group: 'active',
    step: 'startPayment',
    stepAction: 'tabPaid',
    action: 'checkout',
    actionIcon: 'mdi:qrcode'
  },
  {
    code: 4,
    label: 'fulfilled',
    labelIcon: 'eva:checkmark-circle-2-fill',
    group: 'inactive',
    step: 'fulfill',
    stepAction: 'tabFulfilled',
    action: '',
    actionIcon: '' 
  },
  {
    code: 0,
    label: 'canceled',
    labelIcon: 'eva:close-circle-fill',
    group: 'canceled',
    step: 'cancel',
    stepAction: 'tabCanceled',
    action: '',
    actionIcon: '' 
  },
];

export const inactiveTabs = tabStatus
  .filter(status => status.group === 'inactive' || status.group === 'canceled')
  .map(status => status.code.toString());

export const completedTabs = tabStatus
  .filter(status => status.group === 'inactive')
  .map(status => status.code.toString());

export const activeTabs = tabStatus
  .filter(status => status.group === 'active')
  .map(status => status.code.toString());

export const allKanbanTabs = tabStatus
  .map(status => status.code.toString());

export const allTabs = tabStatus
  .map(status => status.code.toString());